import { generateMutations } from '../builder'

export default {
  ...generateMutations('getCharacterFunctions', 'characterFunctions'),
}
